import React from 'react';
import { routes } from 'appConstants';
import { ButtonV4, Link } from 'components';
import { _t } from 'utils';

import bulletIcon from 'assets/img/about-v4/bullet.png';
import ceoPhoto from 'assets/img/about-v4/ceo.jpg';
import joinBg from 'assets/img/about-v4/join-team.png';
import deputy1 from 'assets/img/about-v4/deputy-1.png';
import deputyBelyaeva from 'assets/img/about-v4/deputy-belyaeva.jpg';
import deputyShapovalyuk from 'assets/img/about-v4/deputy-shapovalyuk.jpg';
import deptKvd from 'assets/img/about-v4/dept-kvd.jpg';
import deptIndustry from 'assets/img/about-v4/dept-industry.jpg';
import deptExport from 'assets/img/about-v4/dept-export.jpg';
import workDirectionsBg from 'assets/img/about-v4/work-directions-bg.png';
import linkNews from 'assets/img/about-v4/link-news.png';
import linkEvents from 'assets/img/about-v4/link-events.png';
import linkResolutions from 'assets/img/about-v4/link-resolutions.png';
import linkAnalytics from 'assets/img/about-v4/link-analytics.png';
import topBanner from 'assets/img/main-v4/hero-curve.png';

import styles from './styles.module.scss';

const INTRO_TITLE = 'АНО «Моспром» – продвигаем промышленный потенциал Москвы';

const INTRO_TEXT =
  'АНО «Моспром» – организация, созданная Правительством Москвы для поддержки, развития и продвижения столичной промышленности. Мы помогаем московским предприятиям выходить на международные рынки, организуем масштабные отраслевые мероприятия, проводим аналитические исследования и реализуем спецпроекты, направленные на популяризацию промышленного сектора.';

const DIRECTIONS = [
  'Продвижение промышленности Москвы',
  'Поддержка экспорта и вывод на новые рынки',
  'Привлечение кадров в промышленность Москвы',
];

const ADVANTAGES = [
  {
    title: 'Экспертиза',
    text: 'Глубокое понимание промышленного сектора\nи международных рынков.',
  },
  {
    title: 'Индивидуальный подход',
    text: 'Помогаем каждому предприятию найти оптимальные решения.',
  },
  {
    title: 'Официальная\nподдержка',
    text: 'Работаем под эгидой Правительства Москвы.',
  },
  {
    title: 'Мероприятия всероссийского\nи мирового уровня',
    text: 'Доступ к ключевым\nотраслевым событиям.',
  },
];

const WORK_DIRECTIONS = [
  {
    id: 'export-support',
    title: 'Поддержка\nэкспорта',
    items: [
      'Помогаем московским производителям находить зарубежных партнеров и выходить на новые рынки.',
      'Организуем бизнес-миссии, B2B-переговоры и участие в международных выставках.',
      'Предоставляем аналитику по перспективным направлениям экспорта.',
    ],
  },
  {
    id: 'congress',
    title: 'Конгрессно-выставочные мероприятия',
    items: [
      'Участвуем в организации крупнейших промышленных событий России и за рубежом.',
      'Проводим Московский инвестиционно-промышленный форум, отраслевые конференции и специализированные выставки.',
      'Создаем площадки для диалога между бизнесом, властью и наукой.',
    ],
  },
  {
    id: 'analytics',
    title: 'Аналитика\nи исследования',
    items: [
      'Готовим отчеты о трендах промышленности Москвы и глобальных рынках.',
      'Разрабатываем рекомендации для бизнеса и органов власти.',
      'Анализируем инвестиционный климат и перспективные ниши для развития.',
    ],
  },
  {
    id: 'special',
    title: 'Специальные\nпроекты',
    items: [
      'Реализуем инициативы по повышению престижа рабочих профессий и инженерного образования.',
      'Создали и развиваем проект «Открой Моспром», который помогает молодежи определиться с профессией в промышленности и узнать про нее самое интересное.',
      'Запускаем медиапроекты, рассказывающие о достижениях московской промышленности.',
      'Создали месяц московской промышленности.',
      'Развиваем промышленный туризм в столице.',
    ],
  },
];

const DEPUTIES = [
  {
    id: 'pavlova',
    name: 'Полина Павлова',
    role: 'Советник министра\nПравительства Москвы',
    photo: deputy1,
  },
  {
    id: 'belyaeva',
    name: 'Ксения Беляева',
    role: 'Управление сопровождения промышленности',
    photo: deputyBelyaeva,
  },
  {
    id: 'shapovalyuk',
    name: 'Антон Шаповалюк',
    role: 'Сметно-финансовое\nуправление',
    photo: deputyShapovalyuk,
  },
];

const DEPARTMENTS = [
  {
    id: 'kvd',
    title: 'Управление КВД\nи спецпроектов',
    photo: deptKvd,
  },
  {
    id: 'export',
    title: 'Управление экспортной\nдеятельности',
    photo: deptExport,
  },
  {
    id: 'industry',
    title: 'Управление сопровождения промышленности',
    photo: deptIndustry,
  },
];

const SEE_ALSO = [
  {
    id: 'news',
    title: 'Новости',
    to: routes.media.news.root,
    image: linkNews,
  },
  {
    id: 'events',
    title: 'Мероприятия',
    to: routes.events.root,
    image: linkEvents,
  },
  {
    id: 'resolutions',
    title: 'Меры поддержки',
    to: routes.resolutions.root,
    image: linkResolutions,
  },
  {
    id: 'analytics',
    title: 'Аналитика',
    to: `${routes.resolutions.service.root}/analytics`,
    image: linkAnalytics,
  },
];

const CEO_ADDRESS = '123112, Россия, г. Москва, Пресненская набережная,\nд. 8, стр. 1, этаж 11, пом. IN, комн. 12';
const DEPUTY_ADDRESS = 'г. Москва, Пресненская набережная, д. 8, стр. 1, этаж 11, пом. IN, комн. 12';
const PHONE = '+ 7 (495) 620-20-00 (доб. 39787)';
const EMAIL = 'info@prom.moscow';

const About = () => (
  <div className={styles.page}>
    <div className={styles.banner} aria-hidden>
      <img src={topBanner} alt="" />
    </div>

    <section className={styles.head}>
      <h1 className={styles.title}>{_t('О нас')}</h1>
      <nav className={styles.crumbs} aria-label={_t('Навигация')}>
        <Link to={routes.main.root} className={styles.crumbLink}>
          {_t('Главная')}
        </Link>
        <span className={styles.crumbLine} aria-hidden />
        <span className={styles.crumbCurrent}>{_t('О нас')}</span>
      </nav>
    </section>

    <section className={styles.content}>
      <div className={styles.intro}>
        <h2 className={styles.introTitle}>{_t(INTRO_TITLE)}</h2>
        <p className={styles.introText}>{_t(INTRO_TEXT)}</p>
      </div>

      <div className={styles.side}>
        <h2 className={styles.sideTitle}>
          {_t('Основные направления\nдеятельности')}
        </h2>
        <ul className={styles.list}>
          {DIRECTIONS.map((item) => (
            <li key={item} className={styles.listItem}>
              <img src={bulletIcon} alt="" width={32} height={32} />
              <span>{_t(item)}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>

    <section className={styles.stats}>
      {ADVANTAGES.map((item) => (
        <div key={item.title} className={styles.stat}>
          <div className={styles.statValue}>{_t(item.title)}</div>
          <div className={styles.statLabel}>{_t(item.text)}</div>
        </div>
      ))}
    </section>

    <section
      className={styles.work}
      style={{ backgroundImage: `url(${workDirectionsBg})` }}
    >
      <h2 className={styles.workTitle}>{_t('Направления нашей работы')}</h2>
      <ul className={styles.workGrid}>
        {WORK_DIRECTIONS.map((block) => (
          <li key={block.id} className={styles.workCard}>
            <h3 className={styles.workCardTitle}>{_t(block.title)}</h3>
            <ul className={styles.workList}>
              {block.items.map((item) => (
                <li key={item} className={styles.workListItem}>
                  {_t(item)}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </section>

    <section className={styles.team}>
      <div className={styles.sectionHead}>
        <h2 className={styles.sectionTitle}>{_t('МОСПРОМ в лицах')}</h2>
        <ButtonV4
          to={routes.contacts.root}
          label="Перейти в раздел"
          variant="outline"
          tone="onLight"
          size="sm"
          className={styles.sectionBtn}
        />
      </div>

      <div className={styles.teamTop}>
        <img src={ceoPhoto} alt="" className={styles.ceoPhoto} />
        <div className={styles.ceoCard}>
          <div className={styles.ceoHead}>
            <div className={styles.personRole}>{_t('ГЕНЕРАЛЬНЫЙ ДИРЕКТОР')}</div>
            <div className={styles.personNameOnDark}>{_t('Ольга Старикова')}</div>
          </div>
          <div className={styles.ceoContacts}>
            <p className={styles.contactOnDark}>{_t(CEO_ADDRESS)}</p>
            <a className={styles.contactOnDark} href="tel:+74956202000">
              {_t(PHONE)}
            </a>
            <a className={styles.emailOnDark} href={`mailto:${EMAIL}`}>
              {_t(EMAIL)}
            </a>
          </div>
        </div>
        <div
          className={styles.join}
          style={{ backgroundImage: `url(${joinBg})` }}
        >
          <div className={styles.joinTitle}>{_t('Присоединяйся к нашей команде')}</div>
          <ButtonV4
            to={routes.vacancies.root}
            label="Посмотреть актуальные вакансии"
            variant="outline"
            tone="onDark"
          />
        </div>
      </div>

      <ul className={styles.deputies}>
        {DEPUTIES.map((person) => (
          <li key={person.id} className={styles.deputy}>
            <div className={styles.deputyPanel}>
              <div className={styles.personRoleDark}>
                {_t('ЗАМЕСТИТЕЛЬ ГЕНЕРАЛЬНОГО ДИРЕКТОРА')}
              </div>
              <div className={styles.deputyBody}>
                <div className={styles.personName}>{_t(person.name)}</div>
                <div className={styles.personSub}>{_t(person.role)}</div>
                <div className={styles.deputyContacts}>
                  <p className={styles.contactMeta}>{_t(DEPUTY_ADDRESS)}</p>
                  <a className={styles.contactMeta} href="tel:+74956202000">
                    {_t(PHONE)}
                  </a>
                  <a className={styles.emailMeta} href={`mailto:${EMAIL}`}>
                    {_t(EMAIL)}
                  </a>
                </div>
              </div>
            </div>
            <img src={person.photo} alt="" className={styles.deputyPhoto} />
          </li>
        ))}
      </ul>
    </section>

    <section className={styles.departments}>
      <h2 className={styles.sectionTitle}>{_t('Наши управления')}</h2>
      <ul className={styles.departmentsGrid}>
        {DEPARTMENTS.map((item) => (
          <li
            key={item.id}
            className={styles.department}
            style={{ backgroundImage: `url(${item.photo})` }}
          >
            <div className={styles.departmentTitle}>{_t(item.title)}</div>
          </li>
        ))}
      </ul>
    </section>

    <section className={styles.seeAlso}>
      <h2 className={styles.seeTitle}>{_t('Смотрите также')}</h2>
      <ul className={styles.seeGrid}>
        {SEE_ALSO.map((item) => (
          <li
            key={item.id}
            className={styles.seeCard}
            style={{ backgroundImage: `url(${item.image})` }}
          >
            <div className={styles.seeCardTitle}>{_t(item.title)}</div>
            <ButtonV4
              to={item.to}
              label="Перейти в раздел"
              variant="solid"
              tone="onLight"
            />
          </li>
        ))}
      </ul>
    </section>
  </div>
);

export default About;
